import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Container } from "react-bootstrap";
import { auth } from "./firebase";
import Header from "./components/Header";
import RoomList from "./components/RoomList";
import RoomBookingForm from "./components/RoomBookingForm";
import { useState, useCallback } from "react";
import CalendarView from "./components/CalendarView";
import BookingList from "./components/BookingList";
import AdminDashboard from "./components/AdminDashboard";
import "./App.css";
import AuthGuardMember from "./components/AuthGuardMember";

function App() {
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [bookings, setBookings] = useState([]);
  const [resetForm, setResetForm] = useState(null);
  const [editingBooking, setEditingBooking] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState(null); // New state for selected slot

  const handleSelectRoom = useCallback(
    (room) => {
      setSelectedRoom(room);
      setEditingBooking(null);
      setSelectedSlot(null); // Clear selected slot when changing rooms
      if (typeof resetForm === "function") {
        resetForm();
      }
    },
    [resetForm]
  );

  const handleSelectEvent = useCallback((booking) => {
    setEditingBooking(booking);
    setSelectedSlot(null); // Clear selected slot when selecting an event
  }, []);

  const handleSelectSlot = useCallback((slotInfo) => {
    setSelectedSlot({
      start: slotInfo.start,
      email: auth.currentUser?.email || "",
    });
    setEditingBooking(null); // Clear editing state when selecting a slot
    window.scrollTo(0, 0); // Scroll to form
  }, []);

  return (
    <Router>
      <Header />
      <main className="main-content">
        <Routes>
          <Route
            path="/"
            element={
              <AuthGuardMember>
                <Container className="py-4">
                  <div className="booking-container">
                    <div className="room-selection-section">
                      <RoomList onSelect={handleSelectRoom} />
                    </div>

                    {selectedRoom && (
                      <div className="booking-details-section">
                        <div className="booking-form-container">
                          <RoomBookingForm
                            selectedRoom={selectedRoom}
                            setBookings={setBookings}
                            onReset={setResetForm}
                            editingBooking={editingBooking}
                            selectedSlot={selectedSlot} // Pass selected slot
                          />
                        </div>
                        <div className="calendar-container">
                          <CalendarView
                            room={selectedRoom}
                            bookings={bookings}
                            setBookings={setBookings}
                            onSelectEvent={handleSelectEvent}
                            onSelectSlot={handleSelectSlot} // Pass slot handler
                          />
                        </div>
                        <div className="booking-list-container">
                          <BookingList
                            room={selectedRoom}
                            bookings={bookings}
                            setBookings={setBookings}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </Container>
              </AuthGuardMember>
            }
          />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </main>
    </Router>
  );
}

export default App;
